<ng-container>
  @if (textLabel()) {
    <button
      mat-button
      class="custom-gray-btn clear-btn"
      type="button"
      (click)="$event.stopPropagation(); $event.preventDefault(); onClear()"
    >
      <div class="flex flex-row flex-center items-center gap-2">
        <span class="text-sm font-medium text-blue-500">{{ textLabel() }}</span>
      </div>
    </button>
  } @else {
    <button
      mat-icon-button
      class="custom-gray-btn clear-btn"
      type="button"
      aria-label="Clear"
      (click)="$event.stopPropagation(); $event.preventDefault(); onClear()"
    >
      <mat-icon class="mat-icon-outlined w-[19px] text-[19px] pt-[2px]">clear</mat-icon>
    </button>
  }
</ng-container>
